// @flow
// The call link of an online appointment, read the way the API stores it (VideoUrl in doutore-api):
// a link pasted without the scheme gets https, and only http(s) links with a host are accepted.

export const normalizeVideoLink = (value: ?string): string => {
  const url = String(value || '').trim();
  if (!url) return '';
  return /^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : `https://${url}`;
};

export const isVideoLink = (value: ?string): boolean => {
  try {
    const url = new URL(normalizeVideoLink(value));
    return ['http:', 'https:'].includes(url.protocol) && url.hostname !== '';
  } catch (e) {
    return false;
  }
};
